<script>
// Publishes the name of the record a detail page currently has open so
// AppBreadcrumb can render "Customers / Acme Ltd / Contacts" rather than the
// raw id from the URL.
//
// Each detail page holds its record in a differently shaped object, so instead
// of the breadcrumb reaching into six stores it asks for one string. Components
// override `breadcrumbRecordLabel` and return '' while the record is loading.
//
// Usage:
//   import BreadcrumbRecordMixin from '../BreadcrumbRecordMixin'
//   export default {
//     mixins: [BreadcrumbRecordMixin],
//     computed: {
//       breadcrumbRecordLabel() {
//         return this.customer ? this.customer.custName : ''
//       }
//     }
//   }
//
// A page can also override `breadcrumbRecordType` to name the kind of record where the route
// cannot: /activities/:id holds tasks and activities, so a task's page returns "Task" and the
// crumb reads "Task: <subject>". '' (the default) keeps the route's label ("Activity").

export default {
  computed: {
    breadcrumbRecordLabel() {
      return "";
    },
    breadcrumbRecordType() {
      return "";
    }
  },
  watch: {
    breadcrumbRecordLabel: {
      immediate: true,
      handler(value) {
        this.$store.dispatch("setBreadcrumbRecord", value || "");
      }
    },
    breadcrumbRecordType: {
      immediate: true,
      handler(value) {
        this.$store.dispatch("setBreadcrumbRecordType", value || "");
      }
    }
  },
  destroyed() {
    // On a route swap Vue creates the incoming page before it destroys this
    // one, and a page that already knows its record (a contact opened from a
    // customer's Contacts tab is handed the record before navigation) has
    // published its name by now. Only clear what is still ours.
    // The type goes with the name: cleared only while the name is still ours, so an
    // incoming task opened straight from another keeps its "Task".
    if (this.$store.getters["getBreadcrumbRecord"] === this.breadcrumbRecordLabel) {
      this.$store.dispatch("setBreadcrumbRecord", "");
      this.$store.dispatch("setBreadcrumbRecordType", "");
    }
  }
};
</script>
